export default async (survey, options) => {
  if (options.question.getType() === "dropdown" && options.question.name.includes("occupation")) {
    const url = `/api/v1/paperwork/occupations?skip=${options.skip}&take=${options.take}&filter=${options.filter}`;
    sendRequest(url, (data) => {
      options.setItems(data.occupations, data.total);
    });
  }
};

function sendRequest(url, onloadSuccessCallback) {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onload = () => {
    if (xhr.status === 200) {
      onloadSuccessCallback(JSON.parse(xhr.response));
    }
  };
  xhr.send();
}
